import styled from "styled-components";

export const Container = styled.div`
  background-color: white;
  border-radius: 10px;
  padding-top: 10px;
  height: 100%;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;

  @media (min-width: 769px) {
      padding-top: 100px;
  }
`;

export const Content = styled.div`
  margin: 0 auto;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  & > * {
      margin-bottom: 20px !important;
  }
  
  
`;

export const Info = styled.p`
font-size: 12px;

`;
